import React, { useEffect, useState, useContext, useRef } from "react";
import {
  DataGrid,
  Column,
  FilterRow,
  HeaderFilter,
  LoadPanel,
  Scrolling,
  SearchPanel,
  Toolbar,
  Item,
  MasterDetail,
  Selection,
} from "devextreme-react/data-grid";
import { OidcIdentityContext } from "@rsmus/react-auth";
import { CheckBox } from "devextreme-react";

import Button from "@mui/material/Button";
import { 
  Pagination, 
  Select, 
  MenuItem, 
  FormControl, 
  FormLabel, 
  SelectChangeEvent,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  IconButton,
  Checkbox,
  FormControlLabel,
  Badge,
  Popover,
  Tooltip
} from "@mui/material";
import AddCommentOutlinedIcon from "@mui/icons-material/AddCommentOutlined";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import WarningIcon from "@mui/icons-material/Warning";
import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from "@mui/icons-material/Search";
import { BatchSitesSelectedProps, constants } from "./UpgradeSitesGrids.types";
import { dataGridConfig, defaultPageSize, UPGRADE_SITES_SCREENS } from "../../../constants";
import { HQSiteChangesDTO, HQSiteDetailsDTO } from "../../../api-client-nswag/taxportal-client";
import { useSnackbar } from "../../../hooks";
import { SnackbarMessage } from "../../../hooks/useSnackbar.types";
import { upgradeSiteClientApi } from "../../../api-client-nswag/taxportal-client-runtime";
import { SitetemplateDTO, ComparisonResultDTO } from "../../../api-client-nswag/upgrade-site-client";
import { executeDownload, calculateGridHeight } from "../../../util/Utils";
import { SitesChangesDetail } from "./SitesChangesDetail";
import { SelectionChangedEvent } from "devextreme/ui/data_grid";
import "./BatchSitesSelected.scss";
import { CellRenderDate } from "../../../util/cellRendersAtoms";
import { DialogBox } from "../../../pages/CreateSites/DialogBox";
import { SiteComments } from "../../../pages/CreateSites/siteComments/siteComments";
import "../../../pages/CreateFolders/CreateFolders.scss";
import { ModalSiteChangesDetail } from "./ModalSiteChangesDetail";

type DatagridRefType = DataGrid;
const {
  BUTTON_CONFIRM,
  BUTTON_CANCEL,
  SITES_SELECTED_TITLE,
  FILE_COMPARISON_NAME,
  EXCEL_FILE_EXTENSION,
  ALERT_MESSAGE,
} = constants;
const {
  HQ_SITE_ID,
  ORG_ID,
  MDM_MASTER_CLIENT_ID,
  MDM_CLIENT_ID,
  NAME,
  COMMENTS,
  HAS_COMMENT,
  TEMPLATE_NAME_OLD,
  TEMPLATE_NAME_NEW,
  UPGRADE_DATE,
  UPGRADED_BY,
  STATUS,
  EXCLUDE_7216_CONSENT,
  CUSTOM_PERMISSION_APPLIED,
} = constants.COLUMNS;

const hasCommentLookup = {
  dataSource: [
    { value: true, display: "Y" },
    { value: false, display: "N" },
  ],
  valueExpr: "value",
  displayExpr: "display",
};

const yesNoLookup = {
  dataSource: [
    { value: true, text: "Yes" },
    { value: false, text: "No" },
  ],
  valueExpr: "value",
  displayExpr: "text",
};

const yesNoHeaderFilterData = [
  { text: "Yes", value: ["exclude7216Consent", "=", true] },
  { text: "No", value: ["exclude7216Consent", "=", false] },
];

const BatchSitesSelected = ({
  selectedSitesData,
  setSelectedSites,
  selectedSites,
  templateSelected,
  appName,
  batchGridData,
  setActiveScreen,
  isBatchUpgrade,
  setPageNumber,
  pageNumber,
}: BatchSitesSelectedProps) => {
  const [selectedChanges, setSelectedChanges] = useState<HQSiteChangesDTO[]>([]);
  const [isPending, setIsPending] = useState(false);
  const [changesWStatus, setChangesWStatus] = useState<HQSiteChangesDTO[]>([]);
  const [changesDeployed, setChangesDeployed] = useState<number>(0);
  const [selectedToDownload, setSelectedToDownload] = useState<HQSiteChangesDTO[]>([]);
  const [allSitesData, setAllSitesData] = useState<HQSiteDetailsDTO[]>([]);
  const [searchSitesData, setSearchSitesData] = useState<HQSiteDetailsDTO[]>([]);
  const [sitesGridPending, setSitesGridPending] = useState(false);
  const [totalSitesCount, setTotalSitesCount] = useState<number>(0);
  const [searchTerm, setSearchTerm] = useState<string | null>(null);
  const [isProceedModalOpen, setIsProceedModalOpen] = useState(false);
  const [isDisplayModal, setIsDisplayModal] = useState(false);
  const [idUpgradeSiteTracks, setIdUpgradeSiteTracks] = useState<number>();
  const [modalHqSiteId, setModalHqSiteId] = useState<number>();
  const { user } = useContext(OidcIdentityContext);
  const { showSnackbar } = useSnackbar();
  const [selectedSitesList, setselectedSitesList] = useState<any[]>(selectedSitesData);
  const [selectedBatchRowKeys, setSelectedBatchRowKeys] = useState<any[]>(
    selectedSitesData.map((site: any) => site.hqSiteId)
  );
  const [highlightComments, setHighlightComments] = useState(false);
  const [highlightCustomPermissions, setHighlightCustomPermissions] = useState(false);
  const [isCommentsOpen, setIsCommentsOpen] = useState(false);
  const [selectedCommentData, setSelectedCommentData] = useState<any[]>([]);
  const [commentCounts] = useState<{ [key: number]: number }>({});
  const [filterAnchorEl, setFilterAnchorEl] = useState<HTMLElement | null>(null);
  const [filterPosition, setFilterPosition] = useState<{ top: number; left: number } | null>(null);
  const inFlightRequestRef = useRef<string | null>(null);
  const suppressSelectionChangedRef = useRef(false);
  const suppressSelectionTimeoutRef = useRef<number | null>(null);
  const hasHydratedSelectionRef = useRef(false);
  const prevKeysRef = useRef<any>([]);
  const prevDataRef = useRef<any>([]);
  const batchGridRef = useRef<DatagridRefType>(null);
  
  // Dropdown states
  const [sourceTemplates, setSourceTemplates] = useState<SitetemplateDTO[]>([]);
  const [targetTemplates, setTargetTemplates] = useState<SitetemplateDTO[]>([]);
  const [comparisonResults, setComparisonResults] = useState<ComparisonResultDTO[]>([]);
  const [selectedSourceTemplate, setSelectedSourceTemplate] = useState<string>("");
  const [selectedTargetTemplate, setSelectedTargetTemplate] = useState<string>("");
  const [selectedComparison, setSelectedComparison] = useState<string>("");
  const [comparisonGridData, setComparisonGridData] = useState<any[]>([]);
  const [gridKey, setGridKey] = useState<number>(0); // Key to force grid reset
  const [hasChildGridLoaded, setHasChildGridLoaded] = useState<boolean>(false); // Track if child grid has been expanded
  
  // Dialog states for save comparison
  const [isDialogOpen, setIsDialogOpen] = useState<boolean>(false);
  const [comparisonTagName, setComparisonTagName] = useState<string>("");
  const [goToPageInput, setGoToPageInput] = useState("");

  const hasSitesSelected = selectedSitesList.length > 0;
  const hasAnySelectedChange = selectedChanges.some((change) => (change.siteChanges?.length ?? 0) > 0);
  const isComparisonSelected = !!selectedComparison;
  const isMoreThanFiveSitesSelected = selectedSitesList.length > 5;
  const isAllowApplyChanges =
    (isComparisonSelected && hasSitesSelected) ||
    (!isComparisonSelected && hasSitesSelected && hasAnySelectedChange && !isMoreThanFiveSitesSelected);
  const canScheduleUpgrade =
    isComparisonSelected &&
    hasSitesSelected &&
    hasAnySelectedChange;
  const disableUpgradeNow =
    !hasSitesSelected || !hasAnySelectedChange || isMoreThanFiveSitesSelected;
  const modifySelectedChanges = (newData: HQSiteChangesDTO, isToDownload = false) => {
    const method = !isToDownload ? setSelectedChanges : setSelectedToDownload;
    
    method((prevChanges) => {
      const newChangesData = [...prevChanges];
      const existingIndex = newChangesData.findIndex((change) => change.siteId === newData.siteId);

      if (existingIndex >= 0) {
        newChangesData[existingIndex] = newData;
        return newChangesData;
      }

      return [...newChangesData, newData];
    });
  };

  const removingSelectedChanges = (rowKey: number) => {
    setSelectedChanges((prevChanges) => {
      return prevChanges.filter((change: HQSiteChangesDTO) => change.siteId !== rowKey);
    });
    setSelectedToDownload((prevChanges) => {
      return prevChanges.filter((change: HQSiteChangesDTO) => change.siteId !== rowKey);
    });
  };
  const handleApplyChanges = () => {
    setIsProceedModalOpen(true);
  };

  const handleProceedToUpgrade = () => {
    setIsProceedModalOpen(false);
    setActiveScreen(UPGRADE_SITES_SCREENS.UPGRADE_SITES);
    setPageNumber(pageNumber);
    showSnackbar({ message: SnackbarMessage.PROCEED_TO_BATCH_UPGRADE });
    setIsPending(true);
    const dataToSend = setDataToUpgrade();
    executeUpgrade(dataToSend);
  };

  const handleScheduleUpgrade = async () => {
    setIsProceedModalOpen(false);
    setActiveScreen(UPGRADE_SITES_SCREENS.UPGRADE_SITES);
    setPageNumber(pageNumber);
    setIsPending(true);
    const selectedComparisonTagName =
      comparisonResults.find((comparison) => comparison.id?.toString() === selectedComparison)?.comparisonTagName ||
      selectedComparison ;
    try {
      const siteIds = selectedSitesList.map((item: any) => item.hqSiteId);
      await upgradeSiteClientApi.taxPortal_ScheduleUpgradeSites(        
        siteIds,
        selectedComparisonTagName,
        user?.profile.preferred_username!        
      );
      showSnackbar({ message: "Sites scheduled for upgrade successfully" as SnackbarMessage, severity: "success" });
    } catch (error) {
      showSnackbar({ message: SnackbarMessage.ERROR, severity: "error" });
    } finally {
      setIsPending(false);
    }
  };
  const executeUpgrade = async (dataToSend: HQSiteChangesDTO[]) => {
    const comparisonTargetTemplateId = comparisonGridData?.[0]?.targetTemplateId
      ? String(comparisonGridData[0].targetTemplateId)
      : "";
    const effectiveTemplateId =
      selectedTargetTemplate || comparisonTargetTemplateId || templateSelected || selectedComparison;


    try {
      const resultChanges = await Promise.allSettled(
        dataToSend.map((siteChange) =>
          upgradeSiteClientApi.taxPortal_ProceedToUpgradeSites(
            effectiveTemplateId,
            [siteChange],
            user?.profile.preferred_username!,
            isBatchUpgrade
          )
        )
      );

      const successfulChanges = resultChanges.reduce<HQSiteChangesDTO[]>((accumulator, result) => {
        if (result.status === "fulfilled" && result.value) {
          accumulator.push(...result.value);
        }

        return accumulator;
      }, []);

      setChangesWStatus(successfulChanges);

      if (resultChanges.some((result) => result.status === "rejected")) {
        showSnackbar({ message: SnackbarMessage.ERROR, severity: "error" });
      }

      setIsPending(false);
    } catch (error) {
      showSnackbar({ message: SnackbarMessage.ERROR, severity: "error" });
      setIsPending(false);
    }
  };

  const setDataToUpgrade = () => {
    if (selectedComparison) {
      const latestSelected = selectedChanges[selectedChanges.length - 1];
      const latestAllChanges = selectedToDownload[selectedToDownload.length - 1];

      const selectedComparisonIds = new Set(
        (latestSelected?.siteChanges || []).map((change: any) => change.comparisonId)
      );

      // In comparison mode, apply only currently selected comparison rows to every selected site.
      const siteChanges = (latestAllChanges?.siteChanges || []).filter((change: any) =>
        selectedComparisonIds.has(change.comparisonId)
      );

      return selectedSitesList.map((site: any) => {
        const siteId = site.hqSiteId;

        return {
          siteId,
          siteChanges,
        };
      });
    }

    const selectedSiteIds = selectedSitesList.map((site: any) => site.hqSiteId);
    const selectedSiteIdSet = new Set(selectedSiteIds);
    const selectedBySite = new Map<number, HQSiteChangesDTO>();

    // Keep only selected sites and de-duplicate by siteId. Prefer entries containing selected change details.
    selectedChanges.forEach((change) => {
      const siteId = change.siteId;
      if (!siteId || !selectedSiteIdSet.has(siteId)) {
        return;
      }

      const existing = selectedBySite.get(siteId);
      if (!existing || (change.siteChanges?.length || 0) >= (existing.siteChanges?.length || 0)) {
        selectedBySite.set(siteId, change);
      }
    });

    const hasDirectSiteSelections = selectedSiteIds.some((siteId) => selectedBySite.has(siteId));
    
    if (!hasDirectSiteSelections) {
      const latestSelected = selectedChanges[selectedChanges.length - 1];
      const latestAllChanges = selectedToDownload[selectedToDownload.length - 1];

      const selectedComparisonIds = new Set(
        (latestSelected?.siteChanges || []).map((change: any) => change.comparisonId)
      );

      const siteChanges = (latestAllChanges?.siteChanges || []).filter((change: any) =>
        selectedComparisonIds.has(change.comparisonId)
      );

      return selectedSiteIds.map((siteId) => ({ siteId, siteChanges }));
    }

    return selectedSiteIds.map((siteId) => selectedBySite.get(siteId) || { siteId, siteChanges: [] });
  };
  const goBackAction = () => {
    setSelectedSites([]);
    setselectedSitesList([]);
    prevKeysRef.current = [];
    prevDataRef.current = [];
    setPageNumber(pageNumber);
    setActiveScreen(UPGRADE_SITES_SCREENS.UPGRADE_SITES);
  };

  const handleSourceTemplateChange = (event: SelectChangeEvent<string>) => {
    const value = event.target.value;
    setSelectedSourceTemplate(value);
    setHasChildGridLoaded(false);
    setSelectedToDownload([]);
    
    if (value && value === selectedTargetTemplate) {
      showSnackbar({ message: "Source and target templates must be different" as SnackbarMessage, severity: "warning" });
    }

    // Clear comparison stored and reset grid when source template is selected
    if (value) {
      setSelectedComparison("");
      
      // Find the selected source template
      const sourceTemplate = sourceTemplates.find(t => t.id?.toString() === value);
      
      // Reset grid and update with source template info, preserve target if exists
      const gridData = [{
        latestTemplateId: sourceTemplate?.id,
        latestTemplateName: sourceTemplate?.sitename,
        targetTemplateId: selectedTargetTemplate ? targetTemplates.find(t => t.id?.toString() === selectedTargetTemplate)?.id : null,
        targetTemplateName: selectedTargetTemplate ? targetTemplates.find(t => t.id?.toString() === selectedTargetTemplate)?.sitename : null
      }];
      setComparisonGridData(gridData);
    } else {
      // If clearing source, keep only target if it exists
      if (selectedTargetTemplate) {
        const targetTemplate = targetTemplates.find(t => t.id?.toString() === selectedTargetTemplate);
        const gridData = [{
          latestTemplateId: null,
          latestTemplateName: null,
          targetTemplateId: targetTemplate?.id,
          targetTemplateName: targetTemplate?.sitename
        }];
        setComparisonGridData(gridData);
      } else {
        setComparisonGridData([]);
      }
    }
  };

  const handleTargetTemplateChange = (event: SelectChangeEvent<string>) => {
    const value = event.target.value;
    setSelectedTargetTemplate(value);
    setHasChildGridLoaded(false);
    setSelectedToDownload([]);

    if (value && value === selectedSourceTemplate) {
      showSnackbar({ message: "Source and target templates must be different" as SnackbarMessage, severity: "warning" });
    }

    // Clear comparison stored and reset grid when target template is selected
    if (value) {
      setSelectedComparison("");
      
      // Find the selected target template
      const targetTemplate = targetTemplates.find(t => t.id?.toString() === value);
      
      // Reset grid and update with target template info, preserve source if exists
      const gridData = [{
        latestTemplateId: selectedSourceTemplate ? sourceTemplates.find(t => t.id?.toString() === selectedSourceTemplate)?.id : null,
        latestTemplateName: selectedSourceTemplate ? sourceTemplates.find(t => t.id?.toString() === selectedSourceTemplate)?.sitename : null,
        targetTemplateId: targetTemplate?.id,
        targetTemplateName: targetTemplate?.sitename
      }];
      setComparisonGridData(gridData);
    } else {
      // If clearing target, keep only source if it exists
      if (selectedSourceTemplate) {
        const sourceTemplate = sourceTemplates.find(t => t.id?.toString() === selectedSourceTemplate);
        const gridData = [{
          latestTemplateId: sourceTemplate?.id,
          latestTemplateName: sourceTemplate?.sitename,
          targetTemplateId: null,
          targetTemplateName: null
        }];
        setComparisonGridData(gridData);
      } else {
        setComparisonGridData([]);
      }
    }
  };

  const handleComparisonChange = (event: SelectChangeEvent<string>) => {
    const selectedId = event.target.value;
    setSelectedComparison(selectedId);
    setHasChildGridLoaded(false); // Reset child grid loaded state
    setSelectedToDownload([]); // Clear previous child grid data
    
    if (selectedId) {
      // Clear source and target templates and reset grid when comparison is selected
      setSelectedSourceTemplate("");
      setSelectedTargetTemplate("");
      
      // Reset grid completely before loading comparison data
      setComparisonGridData([]);
      
      const selected = comparisonResults.find(c => c.id?.toString() === selectedId);
      if (selected) {
        const gridData = [{
          latestTemplateId: selected.originTemplateId,
          latestTemplateName: selected.originTemplateName,
          targetTemplateId: selected.targetTemplateId,
          targetTemplateName: selected.targetTemplateName
        }];
        setComparisonGridData(gridData);
      }
    } else {
      setComparisonGridData([]);
    }
  };

  const handleSaveComparison = async () => {
    // Open dialog to get comparison tag name
    setIsDialogOpen(true);
  };

  const handleDialogClose = () => {
    setIsDialogOpen(false);
    setComparisonTagName("");
  };

  const handleDialogSubmit = async () => {
    if (!comparisonTagName.trim()) {
      showSnackbar({ message: "Please enter a comparison tag name" as SnackbarMessage, severity: "error" });
      return;
    }

    try {
      
      // Get grid data from comparisonGridData
      const gridRow = comparisonGridData[0];
      if (!gridRow) {
        showSnackbar({ message: "No comparison data available" as SnackbarMessage, severity: "error" });
        return;
      }

      // If selectedToDownload is empty but child grid was loaded, this is a data capture issue
      if (selectedToDownload.length === 0 && hasChildGridLoaded) {
        showSnackbar({ 
          message: "Data sync issue detected. Please close and re-expand the child grid, then try saving again." as SnackbarMessage, 
          severity: "error" 
        });
        return;
      }

      // Use only the data whose siteId matches the selected source template (gridRow.latestTemplateId).
      // This guards against stale entries from a previously-expanded child grid (e.g. the user opened
      // site 4119 first, then switched the source template to 6742 and opened it again — both entries
      // can coexist in selectedToDownload due to the async fetchData race). Using the entry that
      // matches latestTemplateId ensures the siteChanges payload is consistent with originTemplateId.
      // No fallback: if there is no exact match the siteChanges array stays empty and the guard below
      // tells the user to expand the correct child grid row before saving.
      const representativeSite = selectedToDownload.find(s => s.siteId === gridRow.latestTemplateId);
      const representativeSelected = selectedChanges.find(s => s.siteId === representativeSite?.siteId);
      const selectedComparisonIds = new Set(
        (representativeSelected?.siteChanges || []).map(change => change.comparisonId)
      );

      const siteChanges = (representativeSite?.siteChanges || []).map(change => ({
        comparisonId: change.comparisonId,
        module: change.module,
        upgradeWarning: change.upgradeWarning || [],
        change: change.change,
        object: change.object,
        status: change.status,
        retry: 0,
        selected: selectedComparisonIds.has(change.comparisonId),
        changesDetail: change.changesDetail || []
      }));

      // Validate that we have data to save
      if (siteChanges.length === 0) {
        showSnackbar({ 
          message: "No comparison data found. Please click the chevron to expand and load the child grid data before saving." as SnackbarMessage, 
          severity: "error" 
        });
        return;
      }

      const requestBody = {
        originTemplateId: gridRow.latestTemplateId,
        originTemplateName: gridRow.latestTemplateName,
        targetTemplateId: gridRow.targetTemplateId,
        targetTemplateName: gridRow.targetTemplateName,
        appName: appName,
        userName: user?.profile.preferred_username,
        comparisonTagName: comparisonTagName,
        siteChanges: siteChanges
      };

      await upgradeSiteClientApi.postBatchUpgradeTemplatesComparison(requestBody);
      showSnackbar({ message: "Comparison saved successfully" as SnackbarMessage });
      
      // Refresh comparison results dropdown
      const comparisons = await upgradeSiteClientApi.getComparison_Results(appName);
      setComparisonResults(comparisons || []);
      
      // Disable save button after successful save
      setHasChildGridLoaded(false);
      
      handleDialogClose();
    } catch (error) {
      showSnackbar({ message: "Failed to save comparison" as SnackbarMessage, severity: "error" });
    }
  };

  const handleDeleteComparison = async () => {
    // TODO: Implement delete comparison logic
    if (selectedComparison) {
      showSnackbar({ message: "Comparison deleted successfully" as SnackbarMessage });
      setSelectedComparison("");
      setComparisonGridData([]);
    }
  };

  const handleChildDataLoaded = () => {
    setHasChildGridLoaded(true);
  };

  const renderDetail = (props: any) => {
    const parentKey = props.key;
    const parentComponent = props.component;
    const rowData = props.data;
    
    // Prevent child grid from loading if template IDs are missing
    if (!rowData.latestTemplateId || !rowData.targetTemplateId) {
      return (
        <div style={{ padding: "20px", textAlign: "center", color: "#666" }}>
          <WarningIcon style={{ marginRight: "8px", verticalAlign: "middle" }} />
          Cannot load comparison details. Both Source Template and Target Template are required.
        </div>
      );
    }

    if (rowData.latestTemplateId === rowData.targetTemplateId) {
      return (
        <div style={{ padding: "20px", textAlign: "center", color: "#b26a00" }}>
          <WarningIcon style={{ marginRight: "8px", verticalAlign: "middle" }} />
          Source and target templates are identical — no comparison needed.
        </div>
      );
    }
    
    return (
      <SitesChangesDetail
        parentKey={parentKey}
        parentComponent={parentComponent}
        selectedSites={selectedSites}
        selectedChanges={selectedChanges}
        templateSelected={templateSelected}
        sourceTemplateId={selectedSourceTemplate}
        targetTemplateId={selectedTargetTemplate}
        comparisonId={selectedComparison}
        changesWStatus={changesWStatus}
        isPending={isPending}
        modifySelectedChanges={modifySelectedChanges}
        removingSelectedChanges={removingSelectedChanges}
        isBatchUpgrade={isBatchUpgrade}
        onChildDataLoaded={handleChildDataLoaded}
      />
    );
  };
  const handleExportButton = async () => {
    if (!selectedToDownload) return;
    showSnackbar({ message: SnackbarMessage.COMPARISON_EXCEL_DOWNLOAD_MESSAGE });
    selectedToDownload.forEach((siteChanges) => {
      getExportedFile(siteChanges);
    });
  };
  const getExportedFile = async (siteChanges: HQSiteChangesDTO) => {
    try {
      const base64String = await upgradeSiteClientApi.HQTemplateSiteExcelExport(siteChanges, false);
      if (base64String)
        executeDownload(base64String, String(siteChanges.siteId), FILE_COMPARISON_NAME, EXCEL_FILE_EXTENSION);
    } catch (error) {
      showSnackbar({
        message: SnackbarMessage.DOWNLOAD_FAILED.replace("%site%", String(siteChanges.siteId)) as SnackbarMessage,
        severity: "error",
      });
    }
  };

  const onSelectionchanged = ({ selectedRowKeys }: SelectionChangedEvent) => {
    setSelectedSites(selectedRowKeys);
  };

  const clearSelection = () => {
    setSelectedSites([]);
    setselectedSitesList([]);
    setSelectedBatchRowKeys([]);
    hasHydratedSelectionRef.current = false;
    prevKeysRef.current = [];
    prevDataRef.current = [];
  };
  const beginSuppressSelectionChanged = () => {
    suppressSelectionChangedRef.current = true;
    if (suppressSelectionTimeoutRef.current !== null) {
      window.clearTimeout(suppressSelectionTimeoutRef.current);
      suppressSelectionTimeoutRef.current = null;
    }
  };

  const endSuppressSelectionChanged = () => {
    suppressSelectionTimeoutRef.current = window.setTimeout(() => {
      suppressSelectionChangedRef.current = false;
      suppressSelectionTimeoutRef.current = null;
    }, 0);
  };

  const normalizeSiteKey = (key: any): number => Number(key);

 const onBatchSitesSelectionChanged = (e: SelectionChangedEvent) => {
    if (suppressSelectionChangedRef.current) {
      return;
    }

    const selectionEvent = e as any;
    const visibleRows = e.component.getVisibleRows();
    const visibleKeys = visibleRows.map((row: any) => normalizeSiteKey(row.key));
    const visibleKeySet = new Set(visibleKeys);

    const addedKeys = ((selectionEvent.currentSelectedRowKeys || []) as any[])
      .map((key: any) => normalizeSiteKey(key))
      .filter((key: number) => visibleKeySet.has(key));
    const removedKeys = ((selectionEvent.currentDeselectedRowKeys || []) as any[])
      .map((key: any) => normalizeSiteKey(key))
      .filter((key: number) => visibleKeySet.has(key));

    // Paging/rebind events typically have no deltas; ignore them so we do not mutate selection.
    if (!addedKeys.length && !removedKeys.length) {
      return;
    }

    const previousKeys = (prevKeysRef.current || []).map((key: any) => normalizeSiteKey(key));
    const previousKeySet = new Set(previousKeys);
    const removedKeySet = new Set(removedKeys);

    const updatedKeys = [
      ...previousKeys.filter((key: number) => !removedKeySet.has(key)),
      ...addedKeys.filter((key: number) => !previousKeySet.has(key)),
    ];   

    const visibleDataByKey = new Map<number, HQSiteDetailsDTO>(
      visibleRows.map((row: any) => [normalizeSiteKey(row.key), row.data as HQSiteDetailsDTO])
    );

    const prevDataByKey = new Map<number, HQSiteDetailsDTO>(
      prevDataRef.current.map((row: any) => [normalizeSiteKey(row.hqSiteId), row as HQSiteDetailsDTO])
    );

    addedKeys.forEach((key: number) => {
      const row = visibleDataByKey.get(key);
      if (row) {
        prevDataByKey.set(key, row);
      }
    });

    removedKeys.forEach((key: number) => {
      prevDataByKey.delete(key);
    });

    const updatedData = updatedKeys
      .map((key: number) => prevDataByKey.get(key))
      .filter((row: HQSiteDetailsDTO | undefined): row is HQSiteDetailsDTO => !!row);

    prevKeysRef.current = updatedKeys;
    prevDataRef.current = updatedData;
    setSelectedBatchRowKeys(updatedKeys);
    setselectedSitesList(updatedData);
  };

  const handleBatchGridContentReady = () => {
    const grid = batchGridRef.current?.instance;
    if (!grid || !selectedBatchRowKeys.length) {
      return;
    }

    beginSuppressSelectionChanged();
    grid.selectRows(selectedBatchRowKeys, false);
    endSuppressSelectionChanged();
  };

  const handleSeeDetailsButton = (upgradeTrackId: number, hqSiteId: number) => {
    setIdUpgradeSiteTracks(upgradeTrackId);
    setModalHqSiteId(hqSiteId);
    setIsDisplayModal(true);
  };

  const handleCloseDetailsModal = () => {
    setIdUpgradeSiteTracks(undefined);
    setModalHqSiteId(undefined);
    setIsDisplayModal(false);
  };

  const renderDetails = ({ row: { data } }: any) => {
    const status = String(data?.status || "").trim().toUpperCase();

    if (!data?.status || !data?.idUpgradeSiteTracks || status === "SCHEDULED") return null;

    return (
      <IconButton
        className="dx-datagrid dx-link"
        aria-label="See Details"
        title="See Details"
        onClick={() => handleSeeDetailsButton(data.idUpgradeSiteTracks, data.hqSiteId)}
      >
        <SearchIcon />
      </IconButton>
    );
  };

  const onChangePagination = (e: any, nextPageNumber: number) => {
    if (nextPageNumber === pageNumber) {
      return;
    }
    if (!searchTerm) {
      setAllSitesData([]);
    }
    setPageNumber(nextPageNumber);
  };

  const handleGoToPage = () => {
    const page = parseInt(goToPageInput, 10);
    if (!isNaN(page) && page >= 1 && page <= sitesCount) {
      onChangePagination(null, page);
    }
    setGoToPageInput("");
  };

  const sitesCount = Math.ceil(totalSitesCount / defaultPageSize);

  // Primitive derived value — stable comparison in useEffect dependency
  const currentTemplateId: string | null =
    comparisonGridData.length > 0 && comparisonGridData[0]?.latestTemplateId != null
      ? String(comparisonGridData[0].latestTemplateId)
      : null;

  const refreshButtonOptions = {
    icon: "refresh",
    onClick: () => {
      clearSelection();
      searchTerm ? fetchSitesBySearch() : fetchSitesByStatus();
    },
    hint: "Refresh"
  };

  const handleOpenComments = (siteId: number, rowData: any, e: React.MouseEvent) => {
    e.stopPropagation();
    setSelectedCommentData([rowData]);
    setIsCommentsOpen(true);
  };

  const handleCommentsClose = () => {
    setIsCommentsOpen(false);
    setSelectedCommentData([]);
  };

  const renderCommentsCell = (cellInfo: any) => {
    const rowData = cellInfo?.row?.data;
    if (!rowData) return null;
    const siteId = rowData.hqSiteId;
    const count = commentCounts[siteId] || 0;
    return (
      <IconButton size="small" onClick={(e) => handleOpenComments(siteId, rowData, e)}>
        <Badge badgeContent={count}>
          <AddCommentOutlinedIcon />
        </Badge>
      </IconButton>
    );
  };

  const fetchSitesByStatus = async () => {
    beginSuppressSelectionChanged();
    setSitesGridPending(true);
    try {
      const startIndex = pageNumber === 1 ? 0 : (pageNumber - 1) * defaultPageSize;
      const { sitesUpgradeList, totalCount } = await upgradeSiteClientApi.highQ_GetSitesUpgradeByStatus(
        null,
        null,
        startIndex,
        defaultPageSize,
        appName,
        currentTemplateId,
        highlightComments,
        highlightCustomPermissions
      );
      const normalizedSites = (sitesUpgradeList || []).map((item: any) => ({
        ...item,
        isCustomPermissionApplied: item.isCustomPermissionApplied === true,
      }));
      setAllSitesData(normalizedSites);
      setTotalSitesCount(totalCount || 0);
    } catch (error) {
      showSnackbar({ message: SnackbarMessage.ERROR, severity: "error" });
      setAllSitesData([]);
      setTotalSitesCount(0);
    } finally {
      setSitesGridPending(false);
      endSuppressSelectionChanged();
    }
  };

  const fetchSitesBySearch = async () => {
    beginSuppressSelectionChanged();
    setSitesGridPending(true);
    setAllSitesData([]);
    try {
      const { sitesUpgradeList, totalCount } = await upgradeSiteClientApi.highQ_GetSitesUpgradeBySearch(
        null,
        null,
        searchTerm,
        appName,
        0,
        defaultPageSize,
        highlightComments,
        highlightCustomPermissions,
        currentTemplateId
      );

      let allSearchResults = sitesUpgradeList?.length ? sitesUpgradeList : [];
      const expectedTotal = totalCount || 0;

      if (expectedTotal > allSearchResults.length) {
        const { sitesUpgradeList: fullSitesUpgradeList } = await upgradeSiteClientApi.highQ_GetSitesUpgradeBySearch(
          null,
          null,
          searchTerm,
          appName,
          0,
          expectedTotal,
          highlightComments,
          highlightCustomPermissions,
          currentTemplateId
        );
        allSearchResults = fullSitesUpgradeList?.length ? fullSitesUpgradeList : allSearchResults;
      }

      allSearchResults = allSearchResults.map((item: any) => ({
        ...item,
        isCustomPermissionApplied: item.isCustomPermissionApplied === true,
      }));

      setSearchSitesData(allSearchResults);
      setTotalSitesCount(expectedTotal || allSearchResults.length);
      if (!allSearchResults.length) setAllSitesData([]);
    } catch (error) {
      showSnackbar({ message: SnackbarMessage.ERROR, severity: "error" });
      setSearchSitesData([]);
      setAllSitesData([]);
      setTotalSitesCount(0);
    } finally {
      setSitesGridPending(false);
    }
  };

  useEffect(() => {
    setChangesDeployed(selectedChanges.filter((item) => item.siteChanges && item.siteChanges.length).length);
  }, [selectedChanges]);

  useEffect(() => {
    if (hasHydratedSelectionRef.current && prevKeysRef.current.length > 0) {
      return;
    }
    const initialKeys = selectedSitesData.map((site: any) => site.hqSiteId);
    prevKeysRef.current = initialKeys;
    prevDataRef.current = selectedSitesData;
    setselectedSitesList(selectedSitesData);
    setSelectedBatchRowKeys(initialKeys);
    hasHydratedSelectionRef.current = true;
  }, [selectedSitesData]);

  useEffect(() => {
    const requestKey = `status:${appName}:${pageNumber}:${currentTemplateId ?? ""}`;
    if (searchTerm) {
      return;
    }

    if (inFlightRequestRef.current === requestKey) return;
    inFlightRequestRef.current = requestKey;

    fetchSitesByStatus().finally(() => {
      if (inFlightRequestRef.current === requestKey) {
        inFlightRequestRef.current = null;
      }
    });
  }, [appName, pageNumber, searchTerm, currentTemplateId, highlightComments, highlightCustomPermissions]);

  useEffect(() => {
    if (!searchTerm) {
      setSearchSitesData([]);
      return;
    }

    const requestKey = `search:${appName}:${searchTerm}`;
    if (inFlightRequestRef.current === requestKey) return;
    inFlightRequestRef.current = requestKey;

    fetchSitesBySearch().finally(() => {
      if (inFlightRequestRef.current === requestKey) {
        inFlightRequestRef.current = null;
      }
    });
  }, [appName, searchTerm]);

  useEffect(() => {
    if (!searchTerm) {
      return;
    }

    const startIndex = pageNumber === 1 ? 0 : (pageNumber - 1) * defaultPageSize;
    const endIndex = startIndex + defaultPageSize;
    beginSuppressSelectionChanged();
    setAllSitesData(searchSitesData.slice(startIndex, endIndex));
    endSuppressSelectionChanged();
    setTotalSitesCount(searchSitesData.length);
  }, [searchTerm, pageNumber, searchSitesData]);

   useEffect(() => {
    return () => {
      if (suppressSelectionTimeoutRef.current !== null) {
        window.clearTimeout(suppressSelectionTimeoutRef.current);
      }
    };
  }, []);

  // Fetch dropdown data
  useEffect(() => {
    const fetchDropdownData = async () => {
      try {
        const [sourceTemplates, targetTemplates, comparisons] = await Promise.all([
          upgradeSiteClientApi.getAll_HighQTemplates(appName),
          upgradeSiteClientApi.highQ_GetHQSiteTemplate(appName),
          upgradeSiteClientApi.getComparison_Results(appName)
        ]);
        setSourceTemplates(sourceTemplates || []);
        setTargetTemplates(targetTemplates || []);
        setComparisonResults(comparisons || []);
        setHasChildGridLoaded(true);
      } catch (error) {
        showSnackbar({ message: SnackbarMessage.ERROR, severity: "error" });
      }
    };
    
    fetchDropdownData();
  }, [appName, user]);

  // Reset grid and child grids when comparison data changes
  useEffect(() => {
    // Increment grid key to force re-render and collapse all expanded rows
    setGridKey(prev => prev + 1);
    // Clear selected changes, status changes, and reset selections
    // NOTE: Do NOT clear selectedToDownload here as it contains all child grid data needed for saving
    setSelectedChanges([]);
    setChangesWStatus([]);
    clearSelection();
    setHasChildGridLoaded(false); // Reset child grid loaded state
    setPageNumber(1); // Reset to first page so offset is 0 with the new template filter
    setSearchTerm(null); // Reset global search when template changes
  }, [comparisonGridData, setSelectedSites]);

  return (
    <>
      <div>
        <h4>{SITES_SELECTED_TITLE}</h4>
      </div>

      {/* Dropdown Controls */}
      <div className="dropdown-controls-container">
        <FormControl size="medium" variant="outlined" sx={{ width: 280 }}>
          <FormLabel className="form-label">Comparison stored</FormLabel>
          <Select
            style={{ height: 36, fontSize: "14px" }}
            value={selectedComparison}
            onChange={handleComparisonChange}
            displayEmpty
            MenuProps={{
              style: {
                maxHeight: 300,
              },
            }}
          >
            <MenuItem value="" style={{ fontSize: "14px" }}>
              <em>Select Comparison</em>
            </MenuItem>
            {comparisonResults.map((comparison) => (
              <MenuItem key={comparison.id} value={comparison.id?.toString()} style={{ fontSize: "14px" }}>
                {comparison.comparisonTagName}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <Button
          variant="outlined"
          onClick={handleSaveComparison}
          disabled={!selectedSourceTemplate || !selectedTargetTemplate || !!selectedComparison || !hasChildGridLoaded}
        >
          Save
        </Button>

        <Button
          variant="outlined"
          onClick={handleDeleteComparison}
          disabled={!selectedComparison}
        >
          Delete
        </Button>

        <FormControl size="medium" variant="outlined" sx={{ width: 250 }}>
          <FormLabel className="form-label">Select a Source Template</FormLabel>
          <Select
            style={{ height: 36, fontSize: "14px" }}
            value={selectedSourceTemplate}
            onChange={handleSourceTemplateChange}
            displayEmpty
            MenuProps={{
              style: {
                maxHeight: 300,
              },
            }}
          >
            <MenuItem value="" style={{ fontSize: "14px" }}>
              <em>Select a Template</em>
            </MenuItem>
            {sourceTemplates.map((template) => (
              <MenuItem key={template.id} value={template.id?.toString()} style={{ fontSize: "14px" }}>
                {template.sitename}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl size="medium" variant="outlined" sx={{ width: 250 }}>
          <FormLabel className="form-label">Select a Target Template</FormLabel>
          <Select
            style={{ height: 36, fontSize: "14px" }}
            value={selectedTargetTemplate}
            onChange={handleTargetTemplateChange}
            displayEmpty
            MenuProps={{
              style: {
                maxHeight: 300,
              },
            }}
          >
            <MenuItem value="" style={{ fontSize: "14px" }}>
              <em>Select a Template</em>
            </MenuItem>
            {targetTemplates.map((template) => (
              <MenuItem key={template.id} value={template.id?.toString()} style={{ fontSize: "14px" }}>
                {template.sitename}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>

      <DataGrid
        id="grid-selected"
        key={gridKey}
        keyExpr="latestTemplateId"
        dataSource={(selectedComparison || selectedSourceTemplate || selectedTargetTemplate) ? comparisonGridData : batchGridData}
        {...dataGridConfig}
        style={{ width: "100%" }}
        onSelectionChanged={onSelectionchanged}
        selectedRowKeys={selectedSites}
      >
        <Selection mode="multiple" selectAllMode={"page"} showCheckBoxesMode={"always"} />

        <FilterRow visible />
        <HeaderFilter visible />
        <Scrolling mode="standard" />
        <LoadPanel enabled={false} />

        <Column dataField="latestTemplateId" caption={"Template ID"} minWidth={70} alignment="left" />
        <Column dataField="latestTemplateName" caption={"Tempalate Name"} minWidth={70} alignment="left" />
        <Column dataField="targetTemplateId" caption={"Target Template ID"} minWidth={70} alignment="left" />
        <Column dataField="targetTemplateName" caption={"Target Template Name"} minWidth={70} alignment="left" />
        <MasterDetail enabled render={renderDetail} />
      </DataGrid>

      <div className="counter">
        <h4>
          {sitesGridPending ? "Loading..." : `${selectedSitesList.length} sites selected`}
        </h4>
      </div>

      <DataGrid
        id="grid-batch-site-selector"
        ref={batchGridRef}
        keyExpr="hqSiteId"
        dataSource={allSitesData}
        {...dataGridConfig}
        height={calculateGridHeight(260)}
        style={{ width: "100%", marginTop: 16 }}
        noDataText={sitesGridPending ? "Loading..." : "No data"}
        onSelectionChanged={onBatchSitesSelectionChanged}
        selectedRowKeys={selectedBatchRowKeys}
        onContentReady={handleBatchGridContentReady}
        onRowPrepared={(e) => {
          if (e.rowType !== "data") return;
          if (highlightComments && e.data?.hasComment) {
            e.rowElement.style.backgroundColor = "#ffffcc";
          } else if (highlightCustomPermissions && e.data?.isCustomPermissionApplied) {
            e.rowElement.style.backgroundColor = "#ffffcc";
          } else {
            e.rowElement.style.backgroundColor = "";
          }
        }}
      >
        <Selection mode="multiple" selectAllMode={"page"} showCheckBoxesMode={"always"} />
        <FilterRow visible />
        <HeaderFilter visible />
        <SearchPanel
          text={searchTerm || ""}
          placeholder="Global Search..."
          onTextChange={(e) => {
            setSearchTerm(e || null);
            setPageNumber(1);
          }}
          visible
        />
        <Toolbar>
          <Item name="searchPanel" location="after" />
          <Item location="after">
            <IconButton
              size="small"
              title="Filter"
              onClick={(e) => {
                const rect = e.currentTarget.getBoundingClientRect();
                setFilterPosition({ top: rect.bottom + 4, left: rect.left });
                setFilterAnchorEl(e.currentTarget);
              }}
              color={(highlightComments || highlightCustomPermissions) ? "primary" : "default"}
              className={(highlightComments || highlightCustomPermissions) ? "filter-icon-btn--active" : "filter-icon-btn"}
            >
              <Badge
                badgeContent={[highlightComments, highlightCustomPermissions].filter(Boolean).length || undefined}
                color="primary"
              >
                <FilterAltIcon fontSize="medium" />
              </Badge>
            </IconButton>
          </Item>
          <Item location="after" widget="dxButton" options={refreshButtonOptions} />
        </Toolbar>
        <Scrolling mode="standard" />
        <LoadPanel enabled={false} />
        <Column dataField="hqSiteId" caption={HQ_SITE_ID} minWidth={70} alignment="left" />
        <Column dataField="orgId" caption={ORG_ID} minWidth={135} alignment="left" />
        <Column dataField="mdmMasterClientId" caption={MDM_MASTER_CLIENT_ID} minWidth={135} alignment="left" />
        <Column dataField="mdmClientId" caption={MDM_CLIENT_ID} minWidth={100} alignment="left" />
        <Column minWidth={300} dataField="name" caption={NAME} alignment="left" />
        <Column caption={COMMENTS} minWidth={100} alignment="center" cellRender={renderCommentsCell} />
        <Column
          dataField="hasComment"
          caption={HAS_COMMENT}
          minWidth={120}
          alignment="center"
          lookup={hasCommentLookup}
        />
        <Column
          dataField="isCustomPermissionApplied"
          caption={CUSTOM_PERMISSION_APPLIED}
          width={140}
          alignment="center"
          filterValue={null}
          calculateFilterExpression={(filterValue: any) => {
            if (filterValue === false) {
              return [
                ["isCustomPermissionApplied", "=", false],
                "or",
                ["isCustomPermissionApplied", "=", null],
              ];
            }
            return ["isCustomPermissionApplied", "=", filterValue];
          }}
          cellRender={(rowData) => (
            <CheckBox
              value={!!rowData.data.isCustomPermissionApplied}
              elementAttr={{
                style: "pointer-events: none; opacity: 1;",
              }}
            />
          )}
        />
        <Column minWidth={300} dataField="templateNameOld" caption={TEMPLATE_NAME_OLD} alignment="left" />
        <Column minWidth={300} dataField="templateNameNew" caption={TEMPLATE_NAME_NEW} alignment="left" />
        <Column
          minWidth={300}
          dataField="exclude7216Consent"
          caption={EXCLUDE_7216_CONSENT}
          alignment="left"
          lookup={yesNoLookup}
        >
          <HeaderFilter dataSource={yesNoHeaderFilterData} />
        </Column>
        <Column
          cellRender={({ data }: { data: HQSiteDetailsDTO }) => CellRenderDate(data.upgradeDate!)}
          dataField="upgradeDate"
          caption={UPGRADE_DATE}
          minWidth={180}
          alignment="left"
        />
        <Column dataField="upgradeBy" caption={UPGRADED_BY} minWidth={180} alignment="left" />
        <Column dataField="status" caption={STATUS} minWidth={180} alignment="left" />
        <Column cellRender={renderDetails} type="buttons" caption="Changes detail" />
      </DataGrid>

      <ModalSiteChangesDetail
        handleClose={handleCloseDetailsModal}
        isDisplayModal={isDisplayModal}
        idUpgradeSiteTracks={idUpgradeSiteTracks}
        hqSiteId={modalHqSiteId}
        userEmail={user?.profile.preferred_username}
      />

      <div className="grid-pagination">
        <Pagination onChange={onChangePagination} page={pageNumber} count={sitesCount} variant="outlined" shape="rounded" />
        <div className="go-to-page">
          <span>Go to page</span>
          <input
            className="go-to-page-input"
            type="text"
            value={goToPageInput}
            onChange={(e) => setGoToPageInput(e.target.value)}
            onKeyDown={(e) => { if (e.key === "Enter") handleGoToPage(); }}
            onBlur={handleGoToPage}
            placeholder={String(pageNumber)}
          />
        </div>
      </div>

      <div className="footer-buttons-container">
        <div className="alert-msg alert-text">
          <WarningIcon />
          {ALERT_MESSAGE}
        </div>
        <div className="button-group">
          <Button className="footer-button" onClick={goBackAction} variant="outlined">
            {BUTTON_CANCEL}
          </Button>
          <Tooltip
            title={!isComparisonSelected && isMoreThanFiveSitesSelected ? "sites selected are more than 5 user must schedule it" : ""}
            disableHoverListener={isComparisonSelected || !isMoreThanFiveSitesSelected}
          >
            <span>
              <Button
                className="footer-button"
                disabled={!isAllowApplyChanges}
                onClick={handleApplyChanges}
                variant="outlined"
              >
                {BUTTON_CONFIRM}
              </Button>
            </span>
          </Tooltip>
        </div>
      </div>

      {/* Save Comparison Dialog */}
      <Dialog 
        open={isDialogOpen} 
        onClose={handleDialogClose}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          Change Comparison
          <IconButton
            aria-label="close"
            onClick={handleDialogClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <FormLabel sx={{ display: 'block', mb: 1, mt: 1, fontSize: '0.875rem', fontWeight: 500 }}>
            Comparison Tag Name
          </FormLabel>
          <TextField
            autoFocus
            type="text"
            fullWidth
            variant="outlined"
            value={comparisonTagName}
            onChange={(e) => setComparisonTagName(e.target.value)}
            placeholder="Enter new project name"
          />
        </DialogContent>
        <DialogActions sx={{ padding: '16px 24px' }}>
          <Button 
            onClick={handleDialogSubmit} 
            variant="contained" 
            color="primary"
            disabled={!comparisonTagName.trim()}
          >
            Submit
          </Button>
        </DialogActions>
      </Dialog>

      <DialogBox
        isDisplayModal={isCommentsOpen}
        handleClose={handleCommentsClose}
        title={"Site Comments"}
        btnContinueDisable={true}
      >
        {selectedCommentData.length > 0 ? (
          <SiteComments
            selectedRowData={selectedCommentData[0]}
            commentSource="UpgradeSite"
          />
        ) : (
          <></>
        )}
      </DialogBox>

      <Popover
        open={Boolean(filterPosition)}
        anchorEl={filterAnchorEl}
        onClose={() => { setFilterPosition(null); setFilterAnchorEl(null); }}
        anchorReference="anchorPosition"
        anchorPosition={filterPosition ?? { top: 0, left: 0 }}
      >
        <div style={{ padding: "12px 16px", display: "flex", flexDirection: "column", gap: "6px", minWidth: 260 }}>
          <FormControlLabel
            control={
              <Checkbox
                checked={highlightComments}
                onChange={(e) => {
                  setHighlightComments(e.target.checked);
                  batchGridRef.current?.instance.repaint();
                  inFlightRequestRef.current = null;
                }}
                size="small"
              />
            }
            label="Display sites with comments"
            sx={{ margin: 0, "& .MuiFormControlLabel-label": { fontSize: "13px" } }}
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={highlightCustomPermissions}
                onChange={(e) => {
                  setHighlightCustomPermissions(e.target.checked);
                  batchGridRef.current?.instance.repaint();
                  inFlightRequestRef.current = null;
                }}
                size="small"
              />
            }
            label="Display sites with custom permissions"
            sx={{ margin: 0, "& .MuiFormControlLabel-label": { fontSize: "13px" } }}
          />
          <Button
            size="small"
            variant="outlined"
            disabled={!highlightComments && !highlightCustomPermissions}
            onClick={() => {
              setHighlightComments(false);
              setHighlightCustomPermissions(false);
              batchGridRef.current?.instance.repaint();
              inFlightRequestRef.current = null;
              setFilterPosition(null);
              setFilterAnchorEl(null);
            }}
            style={{ marginTop: 4 }}
          >
            Clear Filter
          </Button>
        </div>
      </Popover>

      <DialogBox
        title="Proceed to upgrade"
        maxWidth="sm"
        isDisplayModal={isProceedModalOpen}
        btnCloseText="Cancel"
        btnEditText="Schedule Upgrade"
        btnOpenText="Upgrade Now"
        btnEditDisable={!canScheduleUpgrade}
        btnContinueDisable={disableUpgradeNow}
        handleClose={() => setIsProceedModalOpen(false)}
        handleEdit={handleScheduleUpgrade}
        handleContinue={handleProceedToUpgrade}
      >
         <div style={{ padding: "24px 0" }}>
          {selectedSitesList.length > 5
            ? "More than 5 sites are selected. These upgrades must be scheduled later."
            : "You can upgrade the selected sites now or schedule later."}
        </div>
      </DialogBox>
    </>
  );
};

export default BatchSitesSelected;
